import { useMutation } from '@tanstack/react-query'

import { generateAnnualFeesInvoice } from '@src/api'
import { useAxios } from '@src/hooks'

export const useGenerateAnnualFeesInvoice = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: { organizationId: string }) => 
      generateAnnualFeesInvoice(axiosInstance, params),
  })
} 
